/** Accent- and case-insensitive comparison, so "materia" finds "Matéria". */
export function normalizeText(value: string): string {
  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

export function matchesQuery(option: string, query: string): boolean {
  const needle = normalizeText(query);
  if (needle === "") return true;
  return normalizeText(option).includes(needle);
}

/**
 * Chosen options come first.
 *
 * A section shows only its first twelve options, so without this a selection
 * made through the search box or the full-list dialog could sit outside the
 * visible window — the user would see no evidence of their own choice (§23.7).
 */
export function orderBySelection(options: string[], selected: string[]): string[] {
  if (selected.length === 0) return options;
  const chosen = new Set(selected);
  const front: string[] = [];
  const rest: string[] = [];
  options.forEach((option) => (chosen.has(option) ? front : rest).push(option));
  return front.concat(rest);
}
